module.exports = __webpack_public_path__ + "img/hora.47024ab5.svg";